import React from "react";
import SectionWrapper from "components/elements/SectionWrapper";
import styles from "./CTASection.module.scss";

const CTASection = (props) => {
	const { alignment } = props;
	return (
		<div className={`text-${alignment ? alignment : "left"}`}>
			<SectionWrapper
				className={`${styles.CTASection}`}
				fluid={false}
				{...props}>
			</SectionWrapper>
		</div>
	);
};

export default CTASection;
